<template>
  <v-layout id="contact-layout">
    <v-container>
      <v-row align="center">
        <v-col class="text-center">
          <h2 class="secondary--text main-title">
            <span>Contact Us</span>
          </h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-alert
            v-model="alert"
            type="error"
            close-text="Close"
            dismissible
          >{{ errorMessage }}</v-alert>
          <v-alert
            v-model="message_sent"
            type="success"
            close-text="Close"
            dismissible
          >Thank you for contacting us.  We will respond as soon as possible.</v-alert>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="text-center">
          <v-form @submit.prevent="sendMessage" v-model="valid" ref="form">
            <v-row>
              <v-col cols="sm" sm="4">
                <v-text-field
                  label="Subject"
                  v-model="subject"
                  :rules="[rules.required, rules.min]"
                  required
                ></v-text-field>
                <v-text-field
                  label="Name"
                  v-model="name"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
                <v-text-field
                  label="E-mail"
                  v-model="email"
                  type="email"
                  :rules="[rules.email]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="sm" sm="8">
                <v-textarea
                  label="Message"
                  v-model="message"
                  auto-grow
                  rows="9"
                  rowheigh="24"
                  outlined
                  counter="500"
                  :rules="[rules.required, rules.max]"
                ></v-textarea>
                <v-checkbox
                  color="secondary"
                  v-model="newsletter"
                  label="Subscribe to newsletter"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="sm" sm="4"></v-col>
              <v-col cols="sm" sm="8" align="end">
                <vue-recaptcha
                  ref="recaptcha"
                  @verify="onVerify"
                  @expired="onExpired"
                  :sitekey="reCaptcha.sitekey"
                  :loadRecaptchaScript="true"
                  class="recaptcha float-right">
                </vue-recaptcha>
              </v-col>
            </v-row>
            <v-row>
              <v-col align="end">                
                <v-btn @click="clear" class="mx-2">Clear</v-btn>
                <v-btn type="submit" class="primary mx-2" :disabled="!formValid" :loading="is_sending">Send</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>
<script>
import VueRecaptcha from 'vue-recaptcha';
import { types as MessageStoreTypes } from "../store/message";
export default {
  computed: {
    formValid() {
      return this.valid && this.reCaptcha.verify !== null && this.reCaptcha.verify !== undefined
    },
    errorMessage() {
      if (this.$store.getters[MessageStoreTypes.getters.ERROR_SENDING] !== null) {
        return this.firebase_message(
          this.$store.getters[MessageStoreTypes.getters.ERROR_SENDING].code,
          this.$store.getters[MessageStoreTypes.getters.ERROR_SENDING].details
        );
      } else {
        return "";
      }
    },
    is_sending() {
      return this.$store.getters[MessageStoreTypes.getters.IS_SENDING];
    },
    message_sent() {
      return this.$store.getters[MessageStoreTypes.getters.SENT];
    },
  },
  watch: {
    errorMessage(value) {
      if (value && value.length > 0) {
        this.alert = true;
      } else {
        this.alert = false;
      }
    },
    message_sent() {
      this.clear();
    },
    alert(value) {
      if (!value) {
        this.$store.commit(MessageStoreTypes.mutations.ERROR_SENDING, null);
      }
    },
    loading() {
    },
  },
  data () {
    return {
      valid: false,
      name: '',
      subject: '',
      email: '',
      newsletter: true,
      message: '',
      alert: false,
      reCaptcha: {
        sitekey: '6LdxabcUAAAAANKUsxMlHX4ip8m_Ldi4Vs8WRxkv',//'6Lc5P7EUAAAAAMljM3BwrnpM47K-hiRjeH2C8BT_'
        verify: null,
      },
      rules: {
        min:  (v) => v && v.length >= 10 || 'Please be a little bit more descriptive (10 character minimum) :)',
        max:  (v) => v && v.length <= 500 || 'Please keep it under 500 characters',
        required: (v) => !!v || 'Required',
        email: (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'This does not look like a valid E-mail address',
      }
    }
  },
  methods: {
    sendMessage () {
      this.$refs.form.validate()
      if (this.valid && this.reCaptcha.verify) {
        const message = {
          emailAddress: this.email,
          name: this.name,
          subject: this.subject,
          message: this.message,
          subscribe: this.newsletter 
        }
        this.$store.dispatch(MessageStoreTypes.actions.SEND_MESSAGE, message);
      }
    },
    clear () {
      this.resetRecaptcha();
      this.$refs.form.reset()
    },
    onVerify: function (response) {
      this.reCaptcha.verify = response;
    },
    onExpired: function () {
      this.reCaptcha.verify = null;
    },
    resetRecaptcha () {
      this.$refs.recaptcha.reset()
      this.reCaptcha.verify = null;
    },
  },
  components: {
    'vue-recaptcha': VueRecaptcha
  }
}
</script>
<style scoped>
  #contact-layout {
    padding: 50px 0px;
  }
</style>